export default {"src":"/evde-internet/_next/static/media/ChevronUpRed.7e49d33c.svg","height":24,"width":25};